import enUS from './en-us';
import nlNL from './nl-nl';

export default {
  'en-US': enUS,
  'nl-NL': nlNL,
};
